import apiProxy from './api-proxy-inst';

class OrderApi {
  adminOrderCount(args) {
    return apiProxy.request('/erpapp_order/count', args).then(data => {
      return data;
    });
  }

  adminOrderList(args) {
    return apiProxy.request('/erpapp_order/list', args).then(data => {
      return data;
    });
  }

  adminModifyPayable(args) {
    return apiProxy.request('/erpapp_order_payable_amount/modify', args).then(data => {
      return data;
    });
  }

  adminOrderCancel(args) {
    return apiProxy.request('/cur_user_erpapp_order/cancel', args).then(data => {
      return data;
    });
  }

  approvedTrial(args) {
    return apiProxy.request('/erpapp_inst_service/trial', args).then(data => {
      return data;
    });
  }

  rejectTrial(args) {
    return apiProxy.request('/erpapp_inst_service/trialReject', args).then(data => {
      return data;
    });
  }
}

export default new OrderApi();